/* LittleG Tool 02 — deterministic tile pack and user-supplied material cost.
 * No vendor price lookup, tax assumptions, checkout, GFun or data persistence.
 */
(function(global){
  'use strict';
  const positive=(raw,max=10000)=>{
    if(raw===''||raw===null||raw===undefined) return null;
    const n=Number(raw);
    return Number.isFinite(n)&&n>0&&n<=max?n:null;
  };
  const range=(raw,min,max)=>{
    if(raw===''||raw===null||raw===undefined) return null;
    const n=Number(raw);
    return Number.isFinite(n)&&n>=min&&n<=max?n:null;
  };
  const rounding=n=>Math.round((n+Number.EPSILON)*100)/100;

  function assessTiles(input){
    if(!input||typeof input!=='object'||Array.isArray(input))return null;
    const length=positive(input.length),width=positive(input.width),
      cover=positive(input.cover),waste=range(input.waste,0,30);
    if([length,width,cover,waste].includes(null))return null;
    const area=length*width;
    if(!Number.isFinite(area)||area>1e8)return null;
    const exclude=(input.exclude===''||input.exclude===null||input.exclude===undefined)
      ?0:range(input.exclude,0,1e8);
    if(exclude===null||exclude>=area)return null;
    const tiledArea=area-exclude;
    const need=tiledArea*(1+waste/100);
    const boxes=Math.ceil(need/cover);
    if(!Number.isSafeInteger(boxes)||boxes<1||boxes>1000000)return null;
    const hasPrice=input.boxPrice!==''&&input.boxPrice!==undefined&&input.boxPrice!==null;
    const boxPrice=hasPrice?range(input.boxPrice,0,100000):null;
    if(hasPrice&&boxPrice===null)return null;
    const cost=boxPrice===null?null:boxes*boxPrice;
    if(cost!==null&&!Number.isFinite(cost))return null;
    return{
      contract:'littleg_tiles_estimate_v1',
      status:'estimate',
      area_m2:rounding(area),
      excluded_area_m2:rounding(exclude),
      tiled_area_m2:rounding(tiledArea),
      waste_percent:waste,
      required_coverage_m2:rounding(need),
      box_coverage_m2:cover,
      boxes,
      purchase_coverage_m2:rounding(boxes*cover),
      material_cost_hkd:cost===null?null:rounding(cost),
      price_basis:cost===null?'no_price_given':'user_supplied_hkd_per_box',
      formal_quantity_survey:false
    };
  }
  if(typeof module!=='undefined'&&module.exports)module.exports={assessTiles,positive,range};
  if(!global.document)return;
  const fmt=n=>new Intl.NumberFormat(undefined,{maximumFractionDigits:2}).format(n);
  global.document.querySelectorAll('[data-littleg-tiles-tool]').forEach(form=>{
    const headline=form.querySelector('[data-tiles-headline]');
    const output=form.querySelector('[data-tiles-result]');
    const cost=form.querySelector('[data-tiles-cost]');
    const container=form.querySelector('[data-tiles-result-container]');
    if(!headline||!output||!cost||!container)return;
    const zh=form.dataset.tilesLocale!=='en';
    const fields=[...form.querySelectorAll('[data-tiles-field]')];
    function render(){
      const values=Object.fromEntries(fields.map(field=>[field.dataset.tilesField,field.value.trim()]));
      const missing=['length','width','cover'].filter(key=>values[key]==='');
      cost.hidden=true;cost.textContent='';
      if(missing.length){
        container.dataset.state='idle';
        headline.textContent=zh?'輸入地面和地磚包裝資料':'Enter the floor and tile packaging details';
        output.textContent=zh?'還差 '+missing.length+' 項必要資料。':missing.length+' required input(s) missing.';
        return;
      }
      const result=assessTiles(values);
      if(!result){
        container.dataset.state='invalid';
        headline.textContent=zh?'請核對數值':'Check the dimensions and pack size';
        output.textContent=zh?'尺寸和每箱覆蓋量須大於 0；扣除面積必須小於地面面積；損耗須介乎 0–30%。':'Dimensions and box coverage must be positive. Excluded area must be smaller than floor area. Waste must be 0–30%.';
        return;
      }
      container.dataset.state='ready';
      headline.textContent=zh?'建議預留 '+fmt(result.boxes)+' 箱地磚':'Allow '+fmt(result.boxes)+' whole boxes';
      output.textContent=(zh?'地面約 ':'Gross floor ') +fmt(result.area_m2)+' m²'+
        (zh?'；實鋪面積 ':'; tiled area ')+fmt(result.tiled_area_m2)+' m²'+
        (zh?'；連 '+fmt(result.waste_percent)+'% 損耗約 ':'; including '+fmt(result.waste_percent)+'% waste: ')+
        fmt(result.required_coverage_m2)+' m²。';
      if(result.material_cost_hkd!==null){
        cost.hidden=false;
        cost.textContent=zh?'按你提供的每箱單價，材料估算為 HK$'+fmt(result.material_cost_hkd)+'。':
          'Based on your price per box, estimated material cost: HK$'+fmt(result.material_cost_hkd)+'.';
      }
    }
    form.addEventListener('input',render);
    form.addEventListener('change',render);
    form.addEventListener('submit',event=>{event.preventDefault();render();});
    render();
  });
})(typeof window==='undefined'?globalThis:window);
